import { connect } from 'react-redux'
import PDFButton from 'components/shared/PDFButton'
import { setSignUpModalIsOpen } from 'redux/actions'

const mapStateToProps = (state) => ({
  isLogged: state.user.isLogged
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(PDFButton)
